import axios from "axios";
import {
  GET_NOTIFICATIONS_URL,
  MARK_NOTIFICATION_READ_URL,
  MARK_NOTIFICATIONS_READ_URL,
  MARK_NOTIFICATIONS_SEEN_URL,
} from "../constants";

const handleNotificationError = (err, fallbackMessage) => {
  const status = err.response?.status;
  if (status === 404) {
    return null;
  }
  const message =
    err.response?.data?.error ||
    err.response?.data ||
    err.message ||
    fallbackMessage;
  throw new Error(message);
};

export const fetchNotifications = async ({ authToken, cursor, take }) => {
  try {
    const response = await axios.get(GET_NOTIFICATIONS_URL(cursor, take), {
      headers: { authorization: authToken },
    });
    return response.data;
  } catch (err) {
    handleNotificationError(err, "Unable to fetch notifications.");
    return { items: [], nextCursor: null, unreadCount: 0, unseenCount: 0 };
  }
};

export const markNotificationRead = async ({ authToken, notificationId }) => {
  try {
    await axios.patch(
      MARK_NOTIFICATION_READ_URL(notificationId),
      null,
      {
        headers: { authorization: authToken },
      }
    );
  } catch (err) {
    handleNotificationError(err, "Unable to update notification.");
  }
};

export const markNotificationsRead = async ({ authToken, notificationIds }) => {
  try {
    await axios.patch(
      MARK_NOTIFICATIONS_READ_URL,
      { notificationIds },
      {
        headers: { authorization: authToken },
      }
    );
  } catch (err) {
    handleNotificationError(err, "Unable to update notifications.");
  }
};

export const markNotificationsSeen = async (authToken) => {
  try {
    await axios.patch(
      MARK_NOTIFICATIONS_SEEN_URL,
      null,
      {
        headers: { authorization: authToken },
      }
    );
  } catch (err) {
    handleNotificationError(err, "Unable to update notifications.");
  }
};
